import React from "react";

import { useTranslation } from "react-i18next";

import { Icon } from "components/Icon";
import { useGoBack } from "utils/useGoBack";

type Props = {
  /** Optional explicit fallback route used when there is no in-app history. */
  to?: string;
};

export default function SubHeaderBackButton({ to }: Props) {
  const { t } = useTranslation();
  const { goBack } = useGoBack(to);

  return (
    <button
      type="button"
      onClick={goBack}
      aria-label={t("back")}
      className="group flex items-center gap-1 h-8 ml-2 text-gray-110 hover:text-primary-70 hover:bg-neutral-20 transition-colors cursor-pointer"
    >
      <Icon
        icon="MdArrowForward"
        className="text-gray-110 group-hover:text-primary-70"
        fontSize="20"
      />
    </button>
  );
}
